import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentPage, getLocationPathAndQuery } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { CustomHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerParameter = {
    shipToId?: string;
} & HasOnSuccess &
    HasOnError<string>;

type HandlerType = CustomHandler<HandlerParameter>;

export const DispatchBeginApplyChanges: HandlerType = ({ dispatch }) => {
    dispatch({
        type: "Components/AddressDrawer/BeginApplyChanges",
    });
};

export const ChangeCustomCustomerContext: HandlerType = async ({
    dispatch,
    getState,
    parameter: { onError, shipToId: paramShipToId },
}) => {
    const { fulfillmentMethod, selectedBillTo, selectedShipTo, pickUpWarehouse } = getState().components.addressDrawer;
    const dataWarehouse = getState().WhiteCap.changeCustomerWarehouseData;

    const awaitableChangeCustomerContext = makeHandlerChainAwaitable(changeCustomerContext);
    const isOsnCreateQuotePage = getCurrentPage(getState()).type === "OsnCreateQuotePage";
    const osnQuoteListPageUrl = getPageLinkByPageType(getState(), "OsnQuoteListPage")?.url || "/myAccount/quotes";

    const isOrderDetailsPage = getCurrentPage(getState()).type === "OrderDetailsPage";
    const orderHistoryPageUrl = getPageLinkByPageType(getState(), "OrderHistoryPage")?.url;

    await awaitableChangeCustomerContext({
        billToId: selectedBillTo?.id,
        shipToId: paramShipToId ?? selectedShipTo?.id,
        fulfillmentMethod,
        isDefault: true,
        pickUpWarehouse:
            fulfillmentMethod === FulfillmentMethod.PickUp
                ? pickUpWarehouse
                : dataWarehouse?.Warehouse
                  ? dataWarehouse.Warehouse
                  : null,
        returnUrl: isOsnCreateQuotePage
            ? osnQuoteListPageUrl
            : isOrderDetailsPage
              ? orderHistoryPageUrl
              : getLocationPathAndQuery(getState()),
        onError: (errorMessage: string) => {
            onError?.(errorMessage);
            dispatch({
                type: "Components/AddressDrawer/CompleteApplyChanges",
            });
        },
    })(dispatch, getState);
};

export const DispatchCompleteApplyChanges: HandlerType = ({ dispatch }) => {
    dispatch({
        type: "Components/AddressDrawer/CompleteApplyChanges",
    });
};

export const FireOnSuccess: HandlerType = ({ parameter: { onSuccess } }) => {
    onSuccess?.();
};

export const chain = [
    DispatchBeginApplyChanges,
    ChangeCustomCustomerContext,
    DispatchCompleteApplyChanges,
    FireOnSuccess,
];

const loadCustomApplyChanges = createHandlerChainRunner(chain, "LoadCustomApplyChanges");
export default loadCustomApplyChanges;
